interface SpinnerProps {
  size?: number
  wrapClassName?: string
}

export function Spinner({ size = 28, wrapClassName = 'cg-spinner-wrap' }: SpinnerProps) {
  return (
    <div className={wrapClassName}>
      <span
        className="cg-spinner"
        style={{ width: size, height: size }}
        aria-label="Loading"
      />
    </div>
  )
}
